import styled from "styled-components";

const FacilityContainer = styled.div`
  position: relative;
  min-height: 202px;
  overflow: hidden;
  background: rgb(94, 81, 77);
  border-radius: 0px 24px;
`;

const Container = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
min-height: 202px;
`;

const MotifContainer = styled.div`
  position: absolute;
  right: 0px;
`;

const Title = styled.h5`
  font-family: KBFGDisplay;
  font-weight: bold;
  font-size: 24px;
  line-height: 36px;
  color: rgb(94, 81, 77);
  margin-bottom: 12px;
`;

const TitleItem = styled.p`

padding: 12px 16px 0;
font-family: KBFGText;
font-style: normal;
font-weight: bold;
font-size: 20px;
line-height: 150%;
text-align: left; 
margin: 0; 
`;

const Description = styled.p`
  padding: 0 16px;
  font-family: KBFGText;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 150%;
  height:100px;
  overflow: hidden;
  text-align: left; 
  margin: 0;
`;

const LandingCardBox = function (props) {
  return (
    <div className="mt-0">
      <Title className="mb-4">{props.title}</Title>
      <div className="m-0 mb-2 row">
        {props.items.map((item, i) => {
          return (
            <div
              className="m-0 me-1 me-lg-0 pe-lg-3 mb-3 p-0 col-lg-4 col-12"
              key={`facility-${i}`}
            >
              <FacilityContainer>
                <MotifContainer>
                  <svg
                    width="181"
                    height="122"
                    viewBox="0 0 181 122"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_2501_12848)">
                      <rect
                        width="164.758"
                        height="164.758"
                        rx="12"
                        transform="matrix(0.693642 -0.72032 0.693642 0.72032 91.4526 35.7566)"
                        fill="#F2A900"
                        fillOpacity="0.2"
                      ></rect>
                      <rect
                        width="164.758"
                        height="164.758"
                        rx="12"
                        transform="matrix(0.693642 -0.72032 0.693642 0.72032 0 3.35034)"
                        fill="#F2A900"
                        fillOpacity="0.2"
                      ></rect>
                    </g>
                    <defs>
                      <clipPath id="clip0_2501_12848">
                        <path
                          d="M0 0H165C173.837 0 181 7.16344 181 16V122H0V0Z"
                          fill="white"
                        ></path>
                      </clipPath>
                    </defs>
                  </svg>
                </MotifContainer>
                <Container>
                  <TitleItem className="text-white">
                    {item.subTitleFasilitasBukopinPrioritas}
                  </TitleItem>
                  <Description
                    className="text-wrap text-white"
                    dangerouslySetInnerHTML={{
                      __html: item.descriptionFasilitasBukopinPrioritas,
                    }}
                  />
                </Container>
              </FacilityContainer>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LandingCardBox;
